import * as React from 'react'
export const SvgBag = (props: React.SVGProps<SVGSVGElement>) => (
  <svg data-name="Layer 1" viewBox="0 0 24 24" {...props}>
    <path d="M18.15 8.19h-2.42V6.56a4.15 4.15 0 10-8.29-.06v1.69H5a1 1 0 00-1 1v12.15a1 1 0 001 1h13.15a1 1 0 001-1V9.21a1 1 0 00-1-1.02zM8.49 6.5a3.1 3.1 0 016.19 0v1.69H8.49zm9.62 14.8h-13v-12h2.33v5.1h1V9.25h6.19v5.1h1.05v-5.1h2.38z" />
  </svg>
)
export default SvgBag
